import styled from 'styled-components';
import Input from 'components/Input';

export const StyledSuiteInput = styled(Input)`
  margin: 12px 0;
  border-radius: 3px;
  font-size: 16px;
`;
